export { default as Hero } from "./hero";
export { default as Work } from "./work";
